import type { Currency } from '@weft/types';
import { formatNumber } from '@weft/utils';
import React from 'react';
import { Price } from '../../../../../../components/design/Price';

type InvoicePerUnitUsageChargeItemProps = {
  name: string;
  description?: string;
  pricePerUnit: number;
  totalPrice: number;
  units: number;
  currency: Currency
};

export const InvoicePerUnitUsageChargeItem: React.FC<InvoicePerUnitUsageChargeItemProps> = ({ name, description, pricePerUnit, totalPrice, units, currency }) => {
  return (
    <section className="flex justify-between">
      <div className="flex flex-col gap-y-1">
        <p className="text-xl font-medium text-black">{name}</p>
        <p className="text-[15px] font-normal text-[#6F6F6F]">
          {description}
        </p>
      </div>
      <div className="flex flex-col gap-y-1 text-end">
        <Price
          className="text-xl font-medium text-black"
          currency={currency}
          align="right"
        >
          {totalPrice}
        </Price>
        <Price
          className="text-[15px] font-normal text-[#6F6F6F]"
          prefix={`${formatNumber(units)} X `}
          currency={currency}
        >
          {pricePerUnit}
        </Price>
      </div>
    </section>
  );
};